var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.chipColor,"dark":""}},[_vm._v(" "+_vm._s(_vm.chipText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }